import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CapricornService }           from './capricorn.service';
import { CapricornSettingsComponent } from './capricorn.settings.component';
import { CompanyIntegrationsModel }   from '../companies/models/company.integrations';

export const CapricornStates : Array<NgHybridStateDeclaration> = [
  {
    component: CapricornSettingsComponent,
    name     : 'app.capricorn',
    resolve  : [
      {
        deps     : [ CapricornService ],
        resolveFn: ( capricornService : CapricornService ) : Promise<CompanyIntegrationsModel> => capricornService.getSettings(),
        token    : 'integrations'
      }
    ],
    url: '/capricorn'
  }
];
